module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posit-layout mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"
  }, [_c('header', {
    staticClass: "posit-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("POSTAT")]), _c('span', {
    staticClass: "version"
  }, [_vm._v("@" + _vm._s(_vm.version) + " - v" + _vm._s(_vm.api_version))]), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _c('div', {
    staticClass: "mdl-layout-title",
    attrs: {
      "id": "insert_into_header"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  })]), _c('menu-drawer'), _c('main', {
    staticClass: "mdl-layout__content mdl-color--grey-50",
    attrs: {
      "id": "main"
    }
  }, [_c('router-view', {
    on: {
      "message": function($event) {
        _vm.$emit('message', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a075b18","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Content.vue
// module id = 526
// module chunks = 1